import { Box, Button, Container, Header } from '@amzn/awsui-components-core';
import constants from '../../common/constants';
import React, { useState } from 'react';
import { EditCollectionRightColProps } from './EditCollection';
import { CollectionEventType } from '@amzn/awscat-pattern-library-service-model';
import { IMplServiceClient } from '../../api/IMplServiceClient';
import { MplServiceClientFactory } from '../../api/MplServiceClientFactory';
import BrowserHistory from '../utils/BrowserHistory';
import RouterPaths from '../../common/RouterPaths';

function EditCollectionRightColumn({
  collectionId,
  state,
  publishCollection,
  saveCollection,
  disableAction,
}: EditCollectionRightColProps) {
  const mplService: IMplServiceClient = MplServiceClientFactory.create();
  const [loadingPublish, setLoadingPublish] = useState<boolean>(false);
  const [loadingSave, setLoadingSave] = useState<boolean>(false);
  const [loadingCancel, setLoadingCancel] = useState<boolean>(false);

  const header = <Header variant="h3">{constants.SAVE_CONTROL_HEADER}</Header>;

  const footer = constants.EDIT_COLLECTION_STATUS_FOOTER + state;

  const discardChanges = async () => {
    if (!disableAction) {
      setLoadingCancel(true);
      await mplService.createCollectionEvent(CollectionEventType.UNLOCK, collectionId);
      setLoadingCancel(false);
    }
    BrowserHistory.push(RouterPaths.MY_COLLECTION);
  };

  const saveChanges = async () => {
    setLoadingSave(true);
    await saveCollection();
    setLoadingSave(false);
  };

  const publishChanges = async () => {
    setLoadingPublish(true);
    await publishCollection();
    setLoadingPublish(false);
  };

  return (
    <Box padding={'s'}>
      <Container header={header} footer={footer}>
        <Box padding={{ bottom: 'xxs' }} textAlign="center">
          <Button
            data-edit-collection-right-col-button
            variant="primary"
            onClick={publishChanges}
            loading={loadingPublish}
            disabled={disableAction}
          >
            {constants.PUBLISH_COLLECTION_BUTTON_TEXT}
          </Button>
        </Box>
        <Box padding={{ bottom: 'xxs' }} textAlign="center">
          <Button
            data-edit-collection-right-col-button
            onClick={saveChanges}
            loading={loadingSave}
            disabled={disableAction}
          >
            {constants.SAVE_COLLECTION_BUTTON_TEXT}
          </Button>
        </Box>
        <Button
          data-edit-collection-right-col-button
          onClick={discardChanges}
          loading={loadingCancel}
          ariaLabel="Cancel edit collection"
        >
          {constants.CANCEL_BUTTON_TEXT}
        </Button>
      </Container>
    </Box>
  );
}

export default EditCollectionRightColumn;
